<script lang="ts">
  let {
    label,
    value = $bindable(""),
    type = "text",
    placeholder = "",
    hint,
    disabled = false,
    onkeydown,
    class: cls = "",
  }: {
    label?: string;
    value?: string;
    type?: string;
    placeholder?: string;
    hint?: string;
    disabled?: boolean;
    onkeydown?: (e: KeyboardEvent) => void;
    class?: string;
  } = $props();
</script>

<label class={`block ${cls}`}>
  {#if label}
    <span class="mb-1.5 block text-xs font-medium text-ink-dim">{label}</span>
  {/if}
  <input
    {type}
    {placeholder}
    {disabled}
    {onkeydown}
    bind:value
    class="w-full rounded-md border border-line bg-base/60 px-3 py-2 text-sm text-ink placeholder:text-ink-faint transition-colors focus:border-accent/60 focus:outline-none focus:ring-2 focus:ring-accent/30 disabled:opacity-50"
  />
  {#if hint}
    <span class="mt-1 block text-xs text-ink-faint">{hint}</span>
  {/if}
</label>
